module.exports = __webpack_public_path__ + "./docs/img/big-icon-api_method.7d76cfdd4ca0ca4558568266feb56008.svg";